<template>
  <div class="custom-actions">

    <button v-if="!isModifyDisabled"
            class="ui basic button"
            @click="modifyAction">

      <i class="edit icon"></i>

    </button>

    <button v-if="!isPlayDisabled"
            class="ui basic button"
            @click="() => { playAction(rowData) }">

      <i class="play icon"></i>

    </button>

    <button v-if="!isDeleteDisabled"
            class="ui basic button"
            @click="deleteAction">

      <i class="delete icon"></i>

    </button>

    <component v-if="customActionComponentName !== null"
               :is="customActionComponentName"
               :row-data="rowData"></component>

  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
    },

    customActionComponentName: {
      default: null,
    },

    trackBy: {
      type: String,
    },

    playAction: {
      type: Function,
      default: () => {},
    },

    isModifyDisabled: {
      type: Boolean,
      default: false,
    },

    isPlayDisabled: {
      type: Boolean,
      default: false,
    },

    isDeleteDisabled: {
      type: Boolean,
      default: false,
    },

    toggleDetailRowFunction: {
      type: Function,
    },
  },
  methods: {
    modifyAction() {
      this.toggleDetailRowFunction(this.rowData[this.trackBy]);
    },

    async deleteAction() {
      // eslint-disable-next-line
      if (confirm('정말 삭제하시겠습니까?')) {
        let name = this.$route.name.toLowerCase();
        name = `${name.slice(0, 1).toUpperCase()}${name.slice(1)}`;

        const result = await this.$store.dispatch(`delete${name}`, this.rowData[this.trackBy]);
        this.$toast(result.message);

        if (!result.response) return;

        this.$table.updateField();
        this.toggleDetailRowFunction(this.rowData[this.trackBy]);
      }
    },
  },
};
</script>

<style scoped>
.custom-actions button.ui.button {
  padding: 8px 8px;
}

.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/CustomActions.vue